import apiHandler from '@api/apiHandler';

function storageClientTarget() {

  const STORAGE_CLIENT_KEY = 'CLIENT_TARGET';

  return {
    get() {

      const clientTarget = JSON.parse(localStorage.getItem(STORAGE_CLIENT_KEY));
      return clientTarget;

    },
    save(clientTarget) {

      if (!clientTarget) {

        storageClientTarget.remove();
        return;

      }
      localStorage.setItem(STORAGE_CLIENT_KEY, JSON.stringify(clientTarget));
      apiHandler.setTenant(clientTarget);

    },
    remove() {

      localStorage.removeItem(STORAGE_CLIENT_KEY);
      apiHandler.setTenant();

    },
  };

}

export default storageClientTarget();
